import { environmentType, cloudDomainSuffixes } from '../constants';

/**
 * Each url that ends with ja.org is considered as prod environment
 * For reference please check NODE_ENV variable inside each .env config file
 */

export const isDevEnvironment = process.env.NODE_ENV === environmentType.DEV;
export const isProdEnvironment = process.env.NODE_ENV === environmentType.PROD;
export const isCloudEnvironment = cloudDomainSuffixes.some(suffix =>
	process.env.VUE_APP_API_URL.includes(suffix)
);
